// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum TrafficStatus {
  UpPilot = 0,
  DownPilot = 1,
  PilotHold = 2,
  CancelRearCallRequest = 3,
  ValidPosition = 4,
  CarIsInBlindHatch = 5,
  RemoveNextUpRequence = 6,
  CancellCallRequest = 7
}
